import React, { FC, memo, useMemo, useState } from 'react';

import { DropDownOptions } from 'devextreme-react/lookup';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import CreateModal from './modals/create';

type NomenclatureValue = {
  customNomenclatureNameId: number | null;
};

type NomenclatureProps = {
  nomenclatureId: number | null;
  value: number | null;
  readOnly: boolean;
  onChange: (value: NomenclatureValue) => void;
};

const NomenclatureCustomName: FC<NomenclatureProps> = ({ nomenclatureId, value, readOnly, onChange }) => {
  const requestDataSource: any = useMemo(() => {
    return $createDataSource(`/v1/NomenclatureCustomName/${nomenclatureId}`, 'id');
  }, [nomenclatureId]);

  const [showModalCreate, setShowModalCreate] = useState(false);

  const refresh = () => requestDataSource.reload();

  const searchExpr = useMemo(() => ['name'], []);

  return (
    <AppFieldBox label="Обозначение марки (для документов)" labelTop>
      <div className="d-flex align-center">
        <SelectBox
          stylingMode="underlined"
          readOnly={readOnly}
          style={{ width: '100%' }}
          dataSource={requestDataSource}
          displayExpr="name"
          valueExpr="id"
          searchEnabled={true}
          searchExpr={searchExpr}
          value={value}
          onItemClick={(e) => {
            onChange({
              customNomenclatureNameId: e.itemData.id,
            });
          }}
          buttons={[
            'dropDown',
            {
              name: 'cleare',
              location: 'after',
              options: {
                onClick: () => onChange({ customNomenclatureNameId: null }),
                icon: 'close',
                disabled: !nomenclatureId,
              },
            },
            {
              name: 'createNomeclature',
              location: 'after',
              options: {
                onClick: () => setShowModalCreate(!showModalCreate),
                icon: 'plus',
                disabled: !nomenclatureId,
              },
            },
          ]}
        >
          <DropDownOptions title="Выберите марку" closeOnOutsideClick={true} showTitle={false} />
        </SelectBox>
        <CreateModal
          nomenclatureId={nomenclatureId}
          refresh={refresh}
          visible={showModalCreate}
          changeVisible={setShowModalCreate}
        />
      </div>
    </AppFieldBox>
  );
};

export default memo(NomenclatureCustomName);
